'use es6';

import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { WithUserInfoProvider } from 'reporting-ui-components/components/PlatformReport/UserInfoProvider';
import DatawellInsightPreview from 'reporting-enablement/components/singleReportViewer/fullPage/srv-datawell-insight/DatawellInsightPreview';
import ErrorBoundaryErrorComponent, { ErrorTypes } from 'reporting-enablement/monitoring/ErrorBoundaryErrorComponent';
import { getGatesAndScopes } from '../../selectors/gatesSelector';
import { getRealmTemplateKey
// @ts-expect-error Untyped import
} from '../../utils/reportingIAUtils';
import DescriptiveReportCard from './DescriptiveReportCard';
import { selectIsReportCollectionTemplateRequestPending, selectReportCollectionTemplatesByKey } from '../../redux/reportCollectionTemplates';
// @ts-expect-error Untyped import
import { EVENTS } from '../../lib/usageTracker';
import HomesCardSection from './HomesCardSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DatawellInsightPreviewWithUserInfo = WithUserInfoProvider(DatawellInsightPreview);
const DescriptiveReportsCardsGrid = ({
  reports
}) => {
  const {
    gates,
    scopes
  } = useSelector(getGatesAndScopes);
  const collectionTemplatesByKey = useSelector(selectReportCollectionTemplatesByKey);
  const loading = useSelector(selectIsReportCollectionTemplateRequestPending);
  if (!reports) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h4",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reports.collectionHomes.subSuite.header"
      })
    }), /*#__PURE__*/_jsx(CardGrid, {
      columnSize: 320,
      gutterSize: 32,
      children: reports.map(subAppAndParentIds => {
        const {
          report: subAppKey
        } = subAppAndParentIds;
        const realmTemplateKey = getRealmTemplateKey(subAppKey, gates, scopes);
        const template = collectionTemplatesByKey.get(realmTemplateKey);
        return /*#__PURE__*/_jsx(DescriptiveReportCard, {
          "data-test-id": `${realmTemplateKey}-preview-card`,
          includeDescription: true,
          subAppKey: subAppKey,
          trackingEvent: EVENTS.clickAllReportsCard,
          children: /*#__PURE__*/_jsx(HomesCardSection, {
            centerText: true,
            children: /*#__PURE__*/_jsx(Flex, {
              flexDirection: "column",
              alignItems: "stretch",
              justifyContent: "center",
              blockSize: "250px",
              children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
                layout: "centered",
                paddingBlockEnd: "800"
              }) : template ? /*#__PURE__*/_jsx(DatawellInsightPreviewWithUserInfo, {
                report: template
              }) : /*#__PURE__*/_jsx(ErrorBoundaryErrorComponent, {
                type: ErrorTypes.SUMMARY_PREVIEW,
                compact: true
              })
            })
          })
        }, realmTemplateKey);
      })
    })]
  });
};
export default DescriptiveReportsCardsGrid;